import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Header } from "./components/header";
import { Footer } from "./components/footer";
import ImageWithFallback from "./components/ImageWithFallback";

import "./live.css";
import {
  ChannelEPGS,
  Content,
  Channel,
  ChannelEPGSData,
  LiveChannelEPGS,
  DisplayEPGS,
} from "./globalType";
import {
  displayDuration,
  displayNumber,
  getHost,
  translate,
  translate2,
} from "./utils";
import { useParams } from "react-router-dom";
import { AuthContext } from "./auth";
import { DateTime } from "luxon";
import classNames from "classnames";
import translation from "./translations.json";
import { LiveSubMenu } from "./components/submenu";
import { LiveModal } from "./components/liveModal";

declare var $: any;

type liveProps = {
  goToPage: (page: string, content: Content | null) => void;
};

const categories = [
  { slug: "livetv", text: "ทีวิออนไลน์" },
  { slug: "entertainment", text: "หนัง ซีรีส์ เเละความบันเทิง" },
  { slug: "sports", text: "กีฬาสุดมันส์" },
  { slug: "documentary", text: "สารคดีเเละรายการเด็ก" },
];

function Live(props: liveProps) {
  const { goToPage } = props;
  const [now, setNow] = useState<DateTime | null>(null);
  const [dayInWeek, setDayInWeek] = useState<DateTime[]>([]);

  const [showChannels, setShowChannel] = useState<Channel[]>([]);
  const [showEPGSData, setShowEPGSData] = useState<ChannelEPGSData | null>(
    null
  );
  const [categorySlug, setCategorySlug] = useState<string | undefined>(
    undefined
  );
  const [datetime, setDatetime] = useState<string | undefined>(undefined);
  const [popup, setPopup] = useState<DisplayEPGS | null>(null);

  const authContext = useContext(AuthContext);
  const params = useParams();

  if (categorySlug !== params.categorySlug) {
    setCategorySlug(params.categorySlug);
    setShowEPGSData(null);
    setShowChannel([]);
  }
  if (datetime !== params.datetime) {
    setDatetime(params.datetime);
    setShowEPGSData(null);
  }

  useEffect(() => {
    if (authContext?.lang) {
      const today = DateTime.local().setLocale(authContext?.lang as string);
      setNow(today);
      setDayInWeek([
        today.minus({ days: 3 }),
        today.minus({ days: 2 }),
        today.minus({ days: 1 }),
        today,
        today.plus({ days: 1 }),
        today.plus({ days: 2 }),
        today.plus({ days: 3 }),
      ]);

      let now_time =
        Math.abs(
          Math.floor(
            DateTime.local().startOf("day").diffNow("minutes").as("minutes")
          )
        );
      $(".now-BG").css({ left: `${now_time * 4}px` });
      const width = $(window).width()
      $(".horizontal").scrollLeft((now_time * 4) - width/2)
    }
  }, [authContext?.lang]);

  useEffect(() => {
    if (!categorySlug || categorySlug === "livetv") {
      fetchChannels("digital-tv,free-tv");
    } else if (categorySlug === "entertainment") {
      fetchChannels("entertainment");
    } else if (categorySlug === "sports") {
      fetchChannels("sports");
    } else if (categorySlug === "documentary") {
      fetchChannels("documentary,kids");
    }
  }, [categorySlug, datetime]);

  useEffect(() => {
    fetchShowEGPS();
  }, [showChannels]);

  const fetchChannels = async (slug: string) => {
    const result = await fetchTrending(slug);
    setShowChannel(result.data);
  };

  const fetchShowEGPS = async () => {
    const channel_codes = showChannels.map((c) => c.channel_code);
    if (channel_codes.length > 0) {
      let date = datetime ? datetime : DateTime.local().toFormat("yyyy-LL-dd");
      const result = await fetchEPGS(channel_codes.join(","), date);

      const data: ChannelEPGSData = await makeEPGSData(
        showChannels,
        result.data
      );

      setShowEPGSData(data);
    }
  };

  const handleClick = (content: DisplayEPGS) => {
    setPopup(content);
    $("#liveModal").modal("show");
  };

  const liveTranslation = translation.live;
  type TranslationKey = keyof typeof liveTranslation;

  return (
    <>
      <Header goToPage={goToPage} />
      <LiveSubMenu goToPage={goToPage} />
      <div className="container H-container live-title">
        <p className="text-center">
          {translate2(
            translation.live.topTitle.th,
            translation.live.topTitle.en,
            authContext?.lang
          )}{" "}
          {datetime
            ? DateTime.fromFormat(datetime, "yyyy-LL-dd").toFormat("dd/LL/yyyy")
            : now?.toFormat("dd/LL/yyyy")}
        </p>
        <div className="live-mode">
          {categories.map((cat) => {
            const catSlug = cat.slug as TranslationKey;
            return (
              <CategoryButton
                text={translate2(
                  liveTranslation[catSlug].th,
                  liveTranslation[catSlug].en,
                  authContext?.lang
                )}
                categorySlug={cat.slug}
                pageSlug={params.categorySlug ? params.categorySlug : "livetv"}
                handleClick={goToPage}
              />
            );
          })}
        </div>
      </div>
      <div className="weekly-BG">
        <div className="container H-container week-BG">
          {dayInWeek.map((day: DateTime) => {
            let todayString = params.datetime
              ? params.datetime
              : now?.toFormat("yyyy-LL-dd");
            const cls = classNames({
              today: day.toFormat("yyyy-LL-dd") === todayString,
            });
            return (
              <div
                className={cls}
                onClick={() => {
                  goToPage(
                    `/ondemand/schedule/${
                      params.categorySlug ? params.categorySlug : "livetv"
                    }/${day.toFormat("yyyy-LL-dd")}`,
                    null
                  );
                }}
              >
                {day.toFormat("ccc")}
                <br />
                {day.toFormat("d LLL")}
              </div>
            );
          })}
        </div>
      </div>

      <div className="plan-BG">
        <div className="table-BG">
          <div className="">
            <div style={{ display: "flex" }}>
              <div className="channel-container">
                <div style={{ width: "145px", height: "65px" }} />
                {showChannels.map((channel, index) => {
                  return (
                    <div key={`c-${index}`} className="channel-sticky">
                      <picture>
                        <img src={channel.thumb} />
                      </picture>
                      <p className="channel-title">{channel.title}</p>
                      <p className="channel-no">{channel.digital_no}</p>
                    </div>
                  );
                })}
              </div>
              <div className="horizontal dragscroll">
                <div className="now-BG">
                  <img src="/ondemand/static/img/live/i_now.png" alt="" />
                  <div className="line" />
                </div>
                <div className="timetable-grid">
                  <div className="t">00:00</div>
                  <div className="t">00:30</div>
                  <div className="t">01:00</div>
                  <div className="t">01:30</div>
                  <div className="t">02:00</div>
                  <div className="t">02:30</div>
                  <div className="t">03:00</div>
                  <div className="t">03:30</div>
                  <div className="t">04:00</div>
                  <div className="t">04:30</div>
                  <div className="t">05:00</div>
                  <div className="t">05:30</div>
                  <div className="t">06:00</div>
                  <div className="t">06:30</div>
                  <div className="t">07:00</div>
                  <div className="t">07:30</div>
                  <div className="t">08:00</div>
                  <div className="t">08:30</div>
                  <div className="t">09:00</div>
                  <div className="t">09:30</div>
                  <div className="t">10:00</div>
                  <div className="t">10:30</div>
                  <div className="t">11:00</div>
                  <div className="t">11:30</div>
                  <div className="t">12:00</div>
                  <div className="t">12:30</div>
                  <div className="t">13:00</div>
                  <div className="t">13:30</div>
                  <div className="t">14:00</div>
                  <div className="t">14:30</div>
                  <div className="t">15:00</div>
                  <div className="t">15:30</div>
                  <div className="t">16:00</div>
                  <div className="t">16:30</div>
                  <div className="t">17:00</div>
                  <div className="t">17:30</div>
                  <div className="t">18:00</div>
                  <div className="t">18:30</div>
                  <div className="t">19:00</div>
                  <div className="t">19:30</div>
                  <div className="t">20:00</div>
                  <div className="t">20:30</div>
                  <div className="t">21:00</div>
                  <div className="t">21:30</div>
                  <div className="t">22:00</div>
                  <div className="t">22:30</div>
                  <div className="t">23:00</div>
                  <div className="t">23:30</div>
                </div>
                {showChannels.map((channel, index) => {
                  type EPGSDataType = keyof typeof showEPGSData;
                  const key = channel.channel_code as EPGSDataType;
                  const epgsData: LiveChannelEPGS | null = showEPGSData
                    ? showEPGSData[key]
                    : null;
                  return (
                    <div
                      key={`r-${index}`}
                      style={{
                        display: "grid",
                        gridTemplateColumns: `${
                          epgsData &&
                          epgsData.epgs &&
                          epgsData.epgs.map((e) => `${e.colSpan}px`).join(" ")
                        }`,
                      }}
                    >
                      {epgsData &&
                        epgsData.epgs &&
                        epgsData.epgs.map((e, j) => {
                          
                          return (
                            <div key={`e-${index}${j}`} className="channel-box">
                              <picture
                                className="channel-thumb"
                                onClick={() => {
                                  handleClick(e);
                                }}
                              >
                                <ImageWithFallback
                                  src={e.isStart ? e.thumb: '/ondemand/static/img/default_channel.jpg'}
                                  maxWidth={e.colSpan}
                                  alt="movie"
                                  fallbackSrc="/ondemand/static/img/default_channel.jpg"
                                />
                              </picture>
                              <p className="time">
                                {e.displayStart} - {e.displayEnd}
                              </p>
                              <p className="name">{e.title}</p>
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <LiveModal goToPage={goToPage} content={popup} />
    </>
  );
}

async function fetchTrending(article_category: string) {
  const host = getHost();
  return axios.get(
    `${host}/api/channels-trending?article_category=${article_category}`
  );
}

async function fetchEPGS(channel_code: string, date: string) {
  const host = getHost();
  return axios.get(
    `${host}/api/my-channels-epg?channel_code=${channel_code}&start_date=${date}&end_date=${date}`
  );
}

type CategoryButtonType = {
  text: string;
  handleClick: (page: string, content: Content | null) => void;
  categorySlug: string;
  pageSlug: string | undefined;
};

function CategoryButton(props: CategoryButtonType) {
  const { text, handleClick, categorySlug, pageSlug } = props;
  const cls = classNames({ active: categorySlug === pageSlug });
  return (
    <button
      onClick={() => {
        handleClick(`/ondemand/schedule/${categorySlug}`, null);
      }}
      className={cls}
    >
      {text}
    </button>
  );
}

async function makeEPGSData(channels: Channel[], epgsChannels: ChannelEPGS[]) {
  const now = DateTime.now();
  const data: ChannelEPGSData = {};
  type ChannelEPGDataType = keyof typeof data;
  channels.forEach((c) => {
    const key = c.channel_code as ChannelEPGDataType;
    data[key] = {
      detail: c,
      channel_code: c.channel_code,
      epgs: null,
    };
    const channels: ChannelEPGS | undefined = epgsChannels.find(
      (e: ChannelEPGS) => e.channel_code === c.channel_code
    );
    if (channels) {
      const epgs: any[] = channels.epgs.map((e) => {
        const start = DateTime.fromISO(e.start_date);
        const end = DateTime.fromISO(e.end_date);
        const diff = end.diff(start, "minutes");
        return {
          ...e,
          duration: diff.as("minutes"),
          displayStart: start.toFormat("HH:mm"),
          displayEnd: end.toFormat("HH:mm"),
          colSpan: Math.round(diff.as("minutes") * 4),
          displayDay: start.toFormat("ccc"),
          isStart: now > start,
        };
      });

      data[key].epgs = epgs;
    }
  });

  return data;
}

export default Live;
